// extracted by mini-css-extract-plugin
export default {"container":"NoteQuoteDetail_container__joeqI","timeline":"NoteQuoteDetail_timeline__0FZXi","value":"NoteQuoteDetail_value__Y89g0"};